export default "__VITE_ASSET__fa9e3664__"